import { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  TextField,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  IconButton,
} from "@mui/material";
import { Delete } from "@mui/icons-material";
import dayjs from "dayjs";

import request from "../../../utilities/requests";

const RECIPIENT_LABELS = {
  all: "All Attendees",
  incompleteProfile: "Incomplete Profiles",
  present: "Present",
  notPresent: "Not Present",
  presentNotCheckedIn: "Present But Not Checked In",
  checkedIn: "Checked  In Attendees",
  notCheckedIn: "Not Checked In",
  matched: "Have Matches",
  noMatches: "No Matches",
  needToSign: "Need to Sign Waiver",
  custom: "Custom",
};

const ScheduleMsgDialog = ({ open, close, pairingEventId }) => {
  const [messages, setMessages] = useState([]);

  useEffect(() => {
    if (open) {
      getMessages();
    }
  }, [open]);

  const getMessages = async () => {
    const url = `templates/scheduledmessages/?pairingEventId=${pairingEventId}`;
    const result = await request(url);
    if (result.success) {
      setMessages(result.data);
    }
  };

  const handleDelete = async (id) => {
    const result = await request(`templates/deletescheduledmessage`, "post", {
      id,
    });
    if (result.success) {
      setMessages((prev) => prev.filter((msg) => msg._id !== id));
    }
  };

  return (
    <Dialog open={open} onClose={close} fullWidth>
      <DialogTitle>Scheduled Messages</DialogTitle>
      <DialogContent>
        {messages.length === 0 ? (
          <DialogContentText>No scheduled messages found.</DialogContentText>
        ) : (
          <Table>
            <TableHead>
              <TableRow>
                <TableCell style={{ fontWeight: "bold" }}>Template</TableCell>
                <TableCell style={{ fontWeight: "bold" }}>Send At</TableCell>
                <TableCell style={{ fontWeight: "bold" }}>Recipients</TableCell>
                <TableCell style={{ fontWeight: "bold" }}>Channel</TableCell>
                <TableCell style={{ fontWeight: "bold" }}>Status</TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {messages.map((msg) => (
                <TableRow key={msg._id}>
                  <TableCell>{msg.template}</TableCell>
                  <TableCell>
                    {dayjs(msg.sendAt).local().format("MM/DD/YY hh:mm A")}
                  </TableCell>
                  <TableCell>{RECIPIENT_LABELS[msg.recipientFilter] ?? msg.recipientFilter}</TableCell>
                  <TableCell>{msg.channel}</TableCell>
                  <TableCell>
                    {msg.status}
                    {msg.status === "failed" && msg.note && (
                      <div
                        style={{
                          color: "gray",
                          fontSize: "0.8em",
                          marginTop: 4,
                        }}
                      >
                        {msg.note}
                      </div>
                    )}
                  </TableCell>
                  <TableCell>
                    <IconButton
                      onClick={() => handleDelete(msg._id)}
                      size="small"
                    >
                      <Delete fontSize="small" />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={close}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ScheduleMsgDialog;
